import CoreLayout from './CoreLayout';
import { useImportPublicProject } from '../hooks/useImportPublicProject';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { StepLoader } from './StepLoader';

const CoreLayoutWrapper = (props) => {
  const flags = useFlags();
  const { loading, videoId, error, setError, setLoading, importProject } =
    useImportPublicProject(
      props.apolloClient,
      props.organisationId,
      flags,
      props.shootstaAI
    );

  if (loading || videoId || error) {
    return (
      <StepLoader
        setLoading={setLoading}
        importProject={importProject}
        videoId={videoId}
        error={error}
        history={props.history}
        setError={setError}
      />
    );
  }

  return <CoreLayout {...props} />;
};

export default CoreLayoutWrapper;
